import { Asset, ItemAsset } from "../types/asset";
import { InspectionElement } from "../types/inspection";

export const getPhotoFolderValues = (
    photoFolders: InspectionElement[],
    photoFolder: string | null
) => {
    const mappedPhotoFolders: InspectionElement[] = [];

    if (photoFolder) {
        const photoFolderIds = photoFolder.split(";");

        photoFolderIds.forEach((photoFolderId) => {
            const match = photoFolders.find(
                (photoFolderElement) =>
                    photoFolderElement.Id.toString() === photoFolderId
            );

            if (match) {
                mappedPhotoFolders.push(match);
            }
        });
    }

    return mappedPhotoFolders;
};

export const parseItemImages = (itemImages: string | null) => {
    if (itemImages) {
        const images: ItemAsset[] = JSON.parse(itemImages);

        return images;
    }

    return [];
};

export const mapImageToItemAsset = (image: Asset) => ({
    Id: image.asset_id,
    ReportId: Number(image.metadata["element-id"])
});

export const filterImagesByToLoad = (images: Asset[]) =>
    images.filter((image) => !image.objectURL);

export const loadAssetImages = async (images: Asset[]) => {
    const loaded: Asset[] = [];

    for (const image of images) {
        try {
            const blob = await fetch(image.url).then((r) => r.blob());

            const assetWithImage = {
                ...image,
                objectURL: window.URL.createObjectURL(blob)
            };

            loaded.push(assetWithImage);
        } catch (e) {
            console.warn(e);
        }
    }

    return loaded;
};

export const getImageCount = (images: string | null) =>
    images?.match(/"Id"/g)?.length ?? 0;

export const getMissingAssetIds = (itemImages: string | null, images: Asset[]) => {
    if (!itemImages) {
        return [];
    }

    const parsedImages = parseItemImages(itemImages);

    if (!parsedImages.length) {
        return [];
    }

    const loadedAssetIds = new Set(images.map((image) => image.asset_id));

    return parsedImages
        .filter((parsedImage) => !loadedAssetIds.has(parsedImage.Id))
        .map((parsedImage) => parsedImage.Id);
};

export const sortImagesBySelected = (
    images: Asset[],
    parsedImages: ItemAsset[]
) => {
    if (parsedImages.length) {
        return images
            .slice()
            .sort(
                (a, b) =>
                    parsedImages.findIndex((image) => image.Id === b.asset_id) -
                    parsedImages.findIndex((image) => image.Id === a.asset_id)
            );
    }

    return images;
};

export const getImagesToView = (itemImages: string | null, images: Asset[]) => {
    if (itemImages) {
        const parsedImages = parseItemImages(itemImages);

        if (parsedImages.length) {
            const matched: Asset[] = [];

            parsedImages.forEach((parsedImage) => {
                const match = images.find(
                    (image) => image.asset_id === parsedImage.Id
                );

                if (match) {
                    matched.push(match);
                }
            });

            return matched;
        }
    }

    return [];
};
